import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";



export const ZEGO_ROLE_PREFIX = { patient: "patient_", doctor: "doctor_" };

// Doctor and patient must use the same bookingId
export const getRoomId = (bookingId) => `consultation_${bookingId}`;

export const buildKitToken = async ({ roomId, userId, userName }) => {
  const appId = 770845152;
  const secret = 'bbcdc764e4835e8b6cdcd59a8a9eb549';

  if (!appId || !secret) {
    throw new Error(
      "Zego APP_ID / SERVER_SECRET not found. Check .env variable names and restart the dev server."
    );
  }

  return ZegoUIKitPrebuilt.generateKitTokenForTest(
    appId,
    secret,
    roomId,
    String(userId),
    userName
  );
};